var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
import { companiesApi, applicationsApi } from '@/utils/apiService';
import api from '@/utils/api';
var CompanyContext = createContext(undefined);
export var useCompany = function () {
    var context = useContext(CompanyContext);
    if (!context) {
        throw new Error('useCompany must be used within a CompanyProvider');
    }
    return context;
};
export var CompanyProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), selectedCompany = _b[0], setSelectedCompany = _b[1];
    var _c = useState(null), selectedApplication = _c[0], setSelectedApplication = _c[1];
    var _d = useState([]), companies = _d[0], setCompanies = _d[1];
    var _e = useState([]), applications = _e[0], setApplications = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(null), error = _g[0], setError = _g[1];
    // Load companies and applications on mount
    useEffect(function () {
        loadFromStorage();
    }, []);
    // Listen for auth data updates (when login happens)
    useEffect(function () {
        var handleAuthDataUpdate = function () {
            loadFromStorage();
        };
        window.addEventListener('auth-data-updated', handleAuthDataUpdate);
        return function () { return window.removeEventListener('auth-data-updated', handleAuthDataUpdate); };
    }, []);
    var loadFromStorage = function () {
        try {
            // Load applications and companies from localStorage (set by AuthContext)
            var availableApplications = localStorage.getItem('availableApplications');
            var availableCompanies = localStorage.getItem('availableCompanies');
            var loadedApps = [];
            var loadedCompanies = [];
            if (availableApplications) {
                loadedApps = JSON.parse(availableApplications);
                setApplications(loadedApps);
            }
            if (availableCompanies) {
                loadedCompanies = JSON.parse(availableCompanies);
                setCompanies(loadedCompanies);
            }
            // Load saved selections from localStorage
            var savedCompany = localStorage.getItem('selectedCompany');
            var savedApplication = localStorage.getItem('selectedApplication');
            var selectedApp_1 = null;
            var selectedComp = null;
            // Restore saved application or auto-select first one
            if (savedApplication) {
                selectedApp_1 = JSON.parse(savedApplication);
                setSelectedApplication(selectedApp_1);
            }
            else if (loadedApps.length > 0) {
                // Auto-select first application if none saved
                selectedApp_1 = loadedApps[0];
                setSelectedApplication(selectedApp_1);
                localStorage.setItem('selectedApplication', JSON.stringify(selectedApp_1));
            }
            // Restore saved company or auto-select first matching company
            if (savedCompany) {
                selectedComp = JSON.parse(savedCompany);
                setSelectedCompany(selectedComp);
            }
            else if (selectedApp_1 && loadedCompanies.length > 0) {
                // Auto-select first company that matches the selected application
                var matchingCompany = loadedCompanies.find(function (c) { return c.application === selectedApp_1.id; });
                if (matchingCompany) {
                    selectedComp = matchingCompany;
                    setSelectedCompany(selectedComp);
                    localStorage.setItem('selectedCompany', JSON.stringify(selectedComp));
                }
            }
            // Update headers if both are selected
            if (selectedApp_1 && selectedComp) {
                updateApiHeaders(selectedComp.schema, selectedApp_1.code);
            }
        }
        catch (e) {
            console.error('Error loading from storage:', e);
            // Fallback to API calls if localStorage data is corrupted
            refreshCompanies();
            loadApplications();
        }
        finally {
            setLoading(false);
        }
    };
    var refreshCompanies = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    setError(null);
                    return [4 /*yield*/, companiesApi.getAll()];
                case 1:
                    response = _a.sent();
                    if (response && Array.isArray(response.results)) {
                        setCompanies(response.results);
                    }
                    else if (Array.isArray(response)) {
                        setCompanies(response);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _a.sent();
                    console.error('Error loading companies:', err_1);
                    setError('Failed to load companies');
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var loadApplications = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_2, fallbackApplications;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, applicationsApi.getAll({ is_active: true })];
                case 1:
                    response = _a.sent();
                    if (response && Array.isArray(response.results)) {
                        setApplications(response.results);
                    }
                    else if (Array.isArray(response)) {
                        setApplications(response);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    console.error('Error loading applications:', err_2);
                    fallbackApplications = [
                        { id: 1, code: 'HOTEL_APP', name: 'Hotel Management', description: 'Main hotel application' },
                        { id: 2, code: 'BOOKING_APP', name: 'Booking System', description: 'Booking management application' },
                    ];
                    setApplications(fallbackApplications);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateApiHeaders = function (schema, applicationCode) {
        // Update axios default headers
        if (schema && applicationCode) {
            api.defaults.headers.common['x-schema'] = schema;
            api.defaults.headers.common['x-application'] = applicationCode;
        }
        else {
            delete api.defaults.headers.common['x-schema'];
            delete api.defaults.headers.common['x-application'];
        }
    };
    var selectCompany = function (company) {
        setSelectedCompany(company);
        if (company) {
            localStorage.setItem('selectedCompany', JSON.stringify(company));
        }
        else {
            localStorage.removeItem('selectedCompany');
        }
        // Update API headers
        if (company && selectedApplication) {
            updateApiHeaders(company.schema, selectedApplication.code);
        }
        else {
            updateApiHeaders(null, null);
        }
    };
    var selectApplication = function (application) {
        setSelectedApplication(application);
        if (application) {
            localStorage.setItem('selectedApplication', JSON.stringify(application));
        }
        else {
            localStorage.removeItem('selectedApplication');
        }
        // Update API headers
        if (selectedCompany && application) {
            updateApiHeaders(selectedCompany.schema, application.code);
        }
        else {
            updateApiHeaders(null, null);
        }
    };
    return (_jsx(CompanyContext.Provider, { value: {
            selectedCompany: selectedCompany,
            selectedApplication: selectedApplication,
            companies: companies,
            applications: applications,
            loading: loading,
            error: error,
            selectCompany: selectCompany,
            selectApplication: selectApplication,
            refreshCompanies: refreshCompanies,
            refreshFromStorage: loadFromStorage,
        }, children: children }));
};
